const companies = {
    'IMTC': {
        backgroundColor: '#ffffff',
        url: 'https://www.ipswichmusicaltheatrecompany.com.au',
        logo: '/assets/images/imtc_logo.png',
        entityName: 'Ipswich Musical Theatre Company Inc.',
        companyName: 'Ipswich Musical Theatre Company',
    },
    'THAT': {
        url: 'http://www.thatproductioncompany.com.au',
        companyName: 'THAT Production Company',
        logo: '/assets/images/that_logo_v2.jpeg',
    },
    'TDTF': {
        backgroundColor: '#fff',
        url: 'https://danceandtheatrefactory.com.au',
        companyName: 'The Dance and Theatre Factory',
        entityName: 'On The Boards Theatre Company Pty Ltd',
        logo: '/assets/images/tdtf_logo.png',
    },
    'LEGEND': {
        backgroundColor: 'white',
        url: 'https://www.legendhouse.co',
        companyName: 'Legend House',
        entityName: 'Legend House International Pty Ltd',
        logo: '/assets/images/legend_logo.png',
    },
    'ROAR': {
        backgroundColor: 'white',
        url: 'https://www.roaracademy.com',
        companyName: 'ROAR Academy',
        entityName: 'ROAR Academy',
        logo: '/assets/images/roar_logo.png',
    },
    'RMT': {
        top: '12px',
        backgroundColor: '#8a0b16',
        url: 'http://www.redcliffemusicaltheatre.com',
        companyName: 'Redcliffe Musical Theatre',
        entityName: 'Redcliffe Musical Theatre',
        logo: '/assets/images/rmt_logo.png',
    },
    'VLM': {
        url: 'https://www.vivalamusica.com.au/',
        companyName: 'Viva La Musica',
        logo: '/assets/images/vlm_logo.jpg'
    },
    'SUP': {
        url: 'https://swichupproductions.my.canva.site/',
        backgroundColor: '#000',
        companyName: 'Swich Up Productions',
        logo: '/assets/images/sup_logo.png',
    }
}

export const venues = {
    'WSHS': {
        title: 'Star Theatre, Wynnum State High School',
        address: "25 Peel Street, Manly QLD 4179",
    },
    'FTPSS': {
        title: 'School Hall, Fig Tree Pocket State School',
        address: "72 Cubberla St, Fig Tree Pocket QLD 4069",
    },
    "STAR": {
        title: 'The Star Gold Coast',
        address: '1 Casino Dr, Broadbeach QLD 4218'
    },
    "ICC": {
        title: "Ipswich Civic Centre",
        address: '50 Nicholas St, Ipswich QLD 4305'
    },
    'Studio 188': {
        title: 'Studio 188',
        address: '188 Brisbane St, Ipswich QLD 4305',
    },
    'OCH': {
        title: 'The Old Courthouse',
        address: '75 East St, Ipswich QLD 4305',
    },
    'SCC': {
        title: 'Somerset Civic Centre',
        address: '35 Esk Hampton Rd, Esk QLD 4312'
    },
    'IGGS': {
        title: 'Ipswich Girl\'s Grammar School',
        address: 'Chermside Rd & Queen Victoria Parade, Ipswich QLD 4305'
    },
    'REC': {
        title: 'Redcliffe Entertainment Centre',
        address: 'Downs St, Redcliffe QLD 4020'
    },
    'T102': {
        title: 'Theatre 102',
        address: '102 Anzac Ave, Redcliffe QLD 4020'
    },
    'BTCC': {
        title: 'Brolga Theatre and Convention Centre',
        address: '5 Walker St, Maryborough QLD 4650'
    },
    'TN': {
        title: 'The Twelfth Night Theatre',
        address: '4 Cintra Rd, Bowen Hills QLD 4006'
    },
    'WB': {
        title: 'Witton Barracks',
        address: '9 Lambert Road, Indooroopilly QLD 4068'
    },
    'QPASG': {
        title: 'Speaker\'s Green, Queensland Parliament Annexe',
        address: '2A George St, Brisbane City QLD 4000'
    },
    'QPALCC': {
        title: 'Legislative Council Chamber, Queensland Parliament Annexe',
        address: '2A George St, Brisbane City QLD 4000'
    },
    'BCH': {
        title: 'Brisbane City Hall',
        address:'64 Adelaide St, Brisbane City QLD 4000'
    },
    'MCBG': {
        title: 'Bandstand, Mt Coot-tha Botanic Gardens',
        address: '152 Mount Coot-tha Road, Mt Coot-tha QLD 4066'
    }
}

const volunteerExperienceData = [
    {
        titles: ['Kinky Boots The Musical'],
        companies: ['SUP'],
        roles: ['Stage Manager'],
        season: [{
            venue: "ICC",
            link: 'https://www.ipswichciviccentre.com.au/event/kinky-boots-the-musical/',
            dates: [
                '2026-03-27T19:30:00',
                '2026-03-28T14:30:00',
                '2026-03-28T19:30:00',
                '2026-03-29T14:30:00',
            ]
        }]
    },
    // {
    //     todo: true,
    //     titles: ['Jesus Christ Superstar'],
    //     companies: ['RMT'],
    //     roles: ['Calling Stage Manager'],
    //     season: [{
    //         venue: "REC",
    //         dates: [
    //             '2026-03-05T19:30:00',
    //             '2026-03-06T19:30:00',
    //             '2026-03-07T19:30:00',
    //             '2026-03-07T14:00:00',
    //             '2026-03-08T19:30:00',
    //             '2026-03-08T14:00:00',
    //         ]
    //     }]
    // },
    // {
    //     todo: true,
    //     titles: ['Mary Poppins Jr.'],
    //     companies: ['ROAR', 'RMT'],
    //     roles: ['Calling Stage Manager'],
    //     season: [{
    //         venue: "REC",
    //         dates: [
    //             '2025-02-07T11:00:00',
    //             '2025-02-07T15:00:00',
    //             '2025-02-08T11:00:00',
    //             '2025-02-08T15:00:00',
    //         ]
    //     }]
    // },
    {
        titles: ['Carols at Witton'],
        companies: ['VLM'],
        roles: ['Stage Manager'],
        season: [{
            venue: 'FTPSS',
            dates: [
                '2025-11-29T16:00:00',
            ]
        }]
    },
    {
        titles: ['Opera in the Upper House'],
        companies: ['VLM'],
        roles: ['Stage Manager'],
        season: [{
            venue: 'QPALCC',
            link: 'https://livemusic.net.au/event/33206142-a/opera-in-the-upper-house',
            dates: [
                '2025-09-25T20:00:00',
            ]
        }]
    },
    {
        titles: ['Come From Away'],
        companies: ['IMTC'],
        roles: ['Production Stage Manager'],
        season: [{
            venue: 'ICC',
            link: 'https://www.ipswichciviccentre.com.au/event/come-from-away',
            dates: [
                '2025-09-13T17:30:00',
                '2025-09-14T14:00:00',
                '2025-09-19T17:30:00',
                '2025-09-20T17:30:00',
                '2025-09-21T14:00:00',
            ]
        }]
    },
    {
        titles: ['Opera in the Gardens'],
        companies: ['VLM'],
        roles: ['Stage Manager'],
        season: [{
            venue: 'MCBG',
            dates: [
            '2025-06-01T14:00:00',
            ]
        }]
    },
    {
        titles: ['Jekyll & Hyde The Musical'],
        companies: ['SUP'],
        roles: ['Stage Manager'],
        season: [{
            venue: "ICC",
            link: 'https://www.ipswichciviccentre.com.au/event/jekyll-hyde/',
            dates: [
                '2025-05-09T19:30:00',
                '2025-05-10T14:00:00',
                '2025-05-10T19:30:00',
                '2025-05-11T14:00:00',
            ]
        }]
    },
    {
        titles: ['Charlie and the Chocolate Factory'],
        companies: ['RMT'],
        roles: ['Calling Stage Manager'],
        season: [{
            venue: "REC",
            dates: [
                '2025-03-21T19:30:00',
                '2025-03-22T14:00:00',
                '2025-03-22T19:30:00',
                '2025-03-23T14:00:00',
                '2025-03-28T19:30:00',
                '2025-03-29T14:00:00',
                '2025-03-29T19:30:00',
                '2025-03-30T14:00:00',
            ]
        }]
    },
    {
        titles: ['Mary Poppins Jr.'],
        companies: ['ROAR', 'RMT'],
        roles: ['Calling Stage Manager'],
        season: [{
            venue: "REC",
            dates: [
                '2025-02-01T11:00:00',
                '2025-02-01T15:00:00',
                '2025-02-02T11:00:00',
                '2025-02-02T15:00:00',
            ]
        }]
    },
    {
        titles: ['Carols at Witton'],
        companies: ['VLM'],
        roles: ['Stage Manager'],
        season: [{
            venue: "WB",
            dates: [
                '2024-12-01T17:00:00',
            ]
        }]
    },
    {
        titles: ['Spring Fling on the Green'],
        companies: ['VLM'],
        roles: ['Stage Manager'],
        season: [{
            venue: "QPASG",
            link:'https://events.humanitix.com/speakers-green-spring-fling',
            dates: [
                '2024-10-19T14:00:00',
            ]
        }]
    },
    {
        titles: ['Newsies Jr.'],
        companies: ['ROAR', 'RMT'],
        roles: ['Calling Stage Manager'],
        season: [{
            venue: 'REC',
            dates: [
                '2024-09-27T19:30:00',
                '2024-09-28T14:00:00',
                '2024-09-28T19:30:00',
                '2024-09-29T14:00:00',
            ]
        }]
    },
    {
        titles: ['Guys and Dolls'],
        roles: ['Production Stage Manager'],
        season: [{
            venue: "ICC",
            link: 'https://www.ipswichciviccentre.com.au/event/guys-and-dolls/',
            dates: [
                '2024-09-07T19:30:00',
                '2024-09-08T13:30:00',
                '2024-09-13T19:30:00',
                '2024-09-14T19:30:00',
                '2024-09-15T13:30:00'
            ]
        }],
        companies: ['IMTC']
    },
    {
        titles: ['The Singing Chefs and the Tubthumping Orchestra'],
        companies: ['VLM'],
        roles: ['Stage Manager'],
        season: [{
            venue: "BCH",
            dates: [
                '2024-07-03T11:30:00',
                '2024-07-03T14:30:00',
            ]
        }]
    },
    {
      titles: ['Joseph and the Amazing Technicolor Dreamcoat'],
      companies: ['RMT'],
      roles: ['Calling Stage Manager'],
      season: [{
          venue: 'REC',
          dates: [
              '2024-03-15T19:30:00',
              '2024-03-16T14:00:00',
              '2024-03-16T19:30:00',
              '2024-03-17T14:00:00',
              '2024-03-22T19:30:00',
              '2024-03-23T14:00:00',
              '2024-03-23T19:30:00',
              '2024-03-24T14:00:00',
          ]
      }]
    },
    {
        titles: ['Live! At the Courthouse: Jazz & Swing'],
        companies: ['IMTC'],
        roles: ['Stage Manager'],
        season: [{
            venue: "OCH",
            dates: [
                '2024-03-09T19:30:00',
                '2024-03-10T14:00:00',
            ]
        }]
    },
    {
        titles: ['Shrek The Musical Jr.'],
        companies: ['ROAR', 'RMT'],
        roles: ['Calling Stage Manager'],
        season: [{
            venue: "REC",
            dates: [
                '2024-02-03T14:00:00',
                '2024-02-03T18:00:00',
                '2024-02-04T14:00:00',
                '2024-02-04T18:00:00',
            ]
        }]
    },
    {
        titles: ["The Sound of Music"],
        roles: ["Calling Stage Manager"],
        season: [{venue: "REC", dates: [
'2023-09-29T19:30:00',
'2023-09-30T14:00:00',
'2023-09-30T19:30:00',
'2023-10-01T14:00:00',
'2023-10-06T19:30:00',
'2023-10-07T14:00:00',
'2023-10-07T19:30:00',
'2023-10-08T14:00:00',
            ]}],
        companies: ['RMT'],
    },
    {
      titles: ['Anywhere Festival - Broadway By The Beach'],
    companies: ['RMT'],
    roles: ['Calling Stage Manager'],
    season: [{
        venue: "REC",
        dates: [
            '2023-06-04T15:00:00',
        ]
    },
        {
        venue: "T102",
        dates: [
            '2023-06-09T19:30:00',
            '2023-06-11T18:00:00',
        ]
    }
    ],
    },
    {
        titles: ['Mother and Son'],
        companies: ['IMTC'],
        roles: ['Lighting Designer', 'Operator'],
        season: [{
            venue: "OCH",
            dates: [
                '2023-03-24T19:30:00',
                '2023-03-25T19:30:00',
                '2023-03-26T13:30:00',
                '2023-03-30T19:30:00',
                '2023-03-31T19:30:00',
                '2023-04-01T13:30:00',
                '2023-04-01T19:30:00'
            ]
        }],
    },
    {
        titles: ['Frozen Jr.'],
        companies: ['ROAR', 'RMT'],
        roles: ['Calling Stage Manager'],
        season: [{
            venue: "REC",
            dates: [
                '2023-02-03T19:00:00',
                '2023-02-04T14:00:00',
                '2023-02-04T19:00:00',
                '2023-02-05T14:00:00'
            ]
        },
        {
            venue: "REC",
            dates: [
                '2023-04-01T11:00:00',
                '2023-04-01T15:00:00',
                '2023-04-02T11:00:00',
                '2023-04-02T15:00:00',
            ]
        },
        {
            venue: "TN",
            dates: [
                '2023-12-08T11:00:00',
                '2023-12-09T18:00:00',
                '2023-12-10T11:00:00',
                '2023-12-10T15:00:00',
            ]
        }],
    },
    {
        titles: ['Songs That Won The War'],
        roles: ['Lighting Designer', 'Operator'],
        season: [{
            venue: "OCH",
            dates: ["2022-11-06T13:30:00"],
        }],
        companies: ['IMTC']
    },
    {
        titles: ['We Will Rock You'],
        roles: ['Stage Manager'],
        season: [{
            venue: "ICC",
            dates: [
                '2022-09-10T19:30:00',
                '2022-09-11T13:30:00',
                '2022-09-16T19:30:00',
                '2022-09-17T19:30:00',
                '2022-09-18T13:30:00'
            ]
        }],
        companies: ['IMTC']
    },
    {
        titles: ['Priscilla Queen of the Desert'],
        roles: ['Calling Stage Manager'],
        season: [{
            venue: "REC",
            dates: [
                '2022-03-11T19:30:00',
                '2022-03-12T14:00:00',
                '2022-03-12T19:30:00',
                '2022-03-13T14:00:00',
                '2022-03-18T19:30:00',
                '2022-03-19T14:00:00',
                '2022-03-19T19:30:00',
                '2022-03-20T14:00:00'
            ]
        }, {
            venue: "ICC",
            dates: [
                '2022-05-06T19:30:00',
                '2022-05-07T13:30:00',
                '2022-05-07T19:30:00',
            ]
        }],
        companies: ['RMT']
    },
    {
        titles: ['Grease'],
        roles: ['Calling Stage Manager'],
        season: [{
            venue: "REC",
            dates: ['2022-02-04T19:00:00', '2022-02-05T14:00:00', '2022-02-05T19:00:00', '2022-02-06T14:00:00'],
        }],
        companies: ['ROAR', 'RMT']
    },
    {
        titles: ['Step In Time Dance Showcase 2021', 'The Little Mermaid Jr.'],
        roles: ["Sound Operator"],
        season: [{
            venue: "WSHS",
            dates: ['2021-11-20T19:00:00', '2021-11-21T13:00:00', '2021-11-21T18:00:00'],
        }],
        companies: ['TDTF']
    },
    {
        titles: ['All Together Now!'],
        roles: ["Stage Manager"],
        season: [{
            venue: "STAR",
            dates: ['2021-11-13T19:30:00']
        }],
        companies: ['LEGEND', 'TDTF']
    },
    {
        titles: ["The Pirates of Penzance"],
        roles: ["Stage Manager"],
        season: [{
            venue: "ICC",
            dates: ['2021-09-11T19:30:00', '2021-09-12T13:30:00', '2021-09-17T19:30:00', '2021-09-18T19:30:00', '2021-09-19T13:30:00'],
        }],
        companies: ['IMTC'],
    },
    {
        titles: ["IMTC Goes Platinum (20 Year Anniversary)"],
        roles: ["Stage Manager"],
        season: [{
            venue: "ICC",
            dates: ['2021-04-17T18:00:00'],
        }],
        companies: ['IMTC'],
    },
    {
        titles: ["Mamma Mia!"],
        roles: ["Stage Manager"],
        season: [{
            venue: "ICC",
            dates: "13 - 22 September 2019",
        }],
        companies: ['IMTC'],
    },
    {
        titles: ["Ladies in Black"],
        roles: ["Stage Manager"],
        season: [{
            venue: "OCH",
            dates: "26 April - 5 May 2019",
        }],
        companies: ['IMTC'],
    },
    {
        titles: ["LIVE! AT THE COURTHOUSE"],
        roles: ["Lighting"],
        season: [{venue: "OCH", dates: ['2018-07-21T19:30:00']}],
        companies: ['IMTC'],
    },
    {
        titles: ["Are You Being Served?"],
        roles: ["Lighting Designer & Operator"],
        season: [{venue: "OCH", dates: "25 May - 2 June 2018",}],
        companies: ['IMTC'],
    },
    {
        titles: ["Les Misérables"],
        roles: ["Stage Manager"],
        season: [{venue: "ICC", dates: "8 - 17 September 2017",}],
        companies: ['IMTC'],
    },
    {
        titles: ["Two Weeks with the Queen"],
        description: "TWO WEEKS WITH THE QUEEN adapted by Mary Morris, from the novel by Morris Gleitzman, with new songs by Lizzie Flynn, was presented at Studio 188 from 20 - 29 October 2016",
        roles: ["Lighting Operator"],
        season: [{venue: "Studio 188", dates: '20 - 29 October 2016'}],
        companies: ['THAT']
    },
    {
        titles: ["Wicked!"],
        roles: ["Stage Manager"],
        season: [{venue: "ICC", dates: "9 - 18 September 2016",}],
        companies: ['IMTC'],
    },
    {
        titles: ["A Little Princess"],
        roles: ["Lighting Operator"],
        season: [{venue: "IGGS", dates: "8 - 10 July 2016"}],
        companies: ['IMTC'],
    },
    {
        titles: ["LIVE! AT THE COURTHOUSE"],
        roles: ["Lighting"],
        season: [{venue: "OCH", dates: "2 July 2016",}],
        companies: ['IMTC'],
    },
    {
        titles: ["The Vicar of Dibley"],
        roles: ["Lighting & Sound"],
        season: [{venue: "OCH", dates: "22 - 30 April 2016",}],
        companies: ['IMTC'],
    },
    {
        titles: ["Sunday in the Park With George"],
        roles: ["Audio Operator"],
        season: [{venue: "OCH", dates: "5 - 13 February 2016",}],
        companies: ['IMTC'],
    },
    {
        titles: ["Mary Poppins"],
        roles: ["Assistant Stage Manager"],
        season: [{venue: "OCH", dates: "12 - 20 September 2015",}],
        companies: ['IMTC'],
    },
    {
        titles: ["The Vicar of Dibley"],
        roles: ["Lighting & Sound"],
        season: [{venue: 'OCH', dates: "1 - 9 May 2015"}],
        companies: ['IMTC']
    },
    {
        titles: ["LIVE! at the Courthouse"],
        roles: [],
        season: [{venue: 'OCH', dates: "28 February 2015"}],
        companies: ['IMTC']
    },
    {
        titles: ["Pains of Youth"],
        description: "PAINS OF YOUTH by Ferdinand Bruckner in a version by Martin Crimp was presented at Studio 188 from 5 - 15 November 2014",
        roles: ["Pianist"],
        season: [{
            venue: "Studio 188",
            dates: "5 - 15 November 2014",
        }],
        companies: ['THAT']
    },
    {
        titles: ["The Phantom of the Opera"],
        roles: ["Assistant Stage Manager"],
        season: [{venue: "ICC", dates: "12 - 20 September 2014"}],
        companies: ['IMTC'],
    },
    {
        titles: ["Disney's High School Musical Jr.", "Roald Dahl's Snow White and the Seven Dwarves"],
        roles: ["Lighting"],
        season: [{venue: "OCH", dates: "3 - 5 July 2014"}],
        companies: ['IMTC']
    },
    {
        titles: ["Dani Girl"],
        roles: ["Sound"],
        season: [{
            venue: "OCH",
            dates: '23 May - 31 May 2014'
        }, {
            venue: "SCC",
            dates: '14 June 2014'
        }],
        companies: ['IMTC'],
    },
    {
        titles: ["Baby Boomers and Their Music"],
        roles: ["Lighting"],
        season: [{venue: "OCH", dates: "28 March - 5 April 2014",}],
        companies: ['IMTC'],
    },
    {
        titles: ["Songs that Won the War"],
        roles: ["Audio"],
        season: [{venue: "OCH", dates: "11 November 2013",}],
        companies: ['IMTC'],
    },
    {
        titles: ["The Sound of Music"],
        roles: ["Assistant Stage Manager"],
        season: [{venue: "ICC", dates: "21 - 24 September 2013",}],
        companies: ['IMTC'],
    },
    // {
    //     titles: ["A Relaxing Sunday Afternoon"],
    //     roles: [],
    //     season: [{venue: "OCH", dates: "June 2013",}],
    //     companies: ['IMTC'],
    // },
    {
        titles: ["Secrets Every Smart Traveller Should Know"],
        roles: ["Lighting & Sound"],
        season: [{venue: "OCH", dates: "31 May - 8 June 2013",}],
        companies: ['IMTC'],
    },
    {
        titles: ["[TITLE OF SHOW]"],
        roles: ["Projectionist"],
        season: [{venue: "OCH", dates: "8 - 16 February 2013",}],
        companies: ['IMTC'],
    },
    {
        titles: ["Songs that Won the War"],
        roles: ["Audio"],
        season: [{venue: "OCH", dates: "11 November 2012",}],
        companies: ['IMTC'],
    },

    {
        titles: ["The Boy From Oz"],
        roles: ["Ensemble"],
        season: [{venue: "ICC", dates: "14 - 16 September 2012",}],
        companies: ['IMTC'],
    },
    {
        titles: ["Barney's Fair"],
        roles: ["Crew"],
        season: [{venue: "OCH", dates: "16 - 23 June 2012",}],
        companies: ['IMTC'],
    },
    {
        titles: ["Into The Woods"],
        roles: ["Sound"],
        season: [{venue: "OCH", dates: "22 - 28 March 2012",}],
        companies: ['IMTC'],
    },
    {
        titles: ["Songs that Won the War"],
        roles: ["Ensemble"],
        season: [{venue: "OCH", dates: "11 - 13 November 2011",}],
        companies: ['IMTC'],
    }, {
        titles: ["Oliver!"],
        roles: ["Ensemble"],
        season: [{venue: "ICC", dates: "17 - 20 September 2011", }],
        companies: ['IMTC'],
    },
]

export {volunteerExperienceData, companies}
